import { render, staticRenderFns } from "./NormalSkeleton.vue?vue&type=template&id=cba28f86&scoped=true&"
var script = {}
import style0 from "./NormalSkeleton.vue?vue&type=style&index=0&id=cba28f86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba28f86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cba28f86')) {
      api.createRecord('cba28f86', component.options)
    } else {
      api.reload('cba28f86', component.options)
    }
    module.hot.accept("./NormalSkeleton.vue?vue&type=template&id=cba28f86&scoped=true&", function () {
      api.rerender('cba28f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/Skeletons/NormalSkeleton.vue"
export default component.exports